import React, { useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import {
  Paper,
  Box,
  Typography,
  makeStyles,
  Grid,
  IconButton,
} from '@material-ui/core';
import KenSelect from '../../components/KenSelect';
import KenButton from '../../components/KenButton';
import clsx from 'clsx';
import KenCheckbox from '../../components/KenCheckbox';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import '../../themes/styles.scss';
import configContext from '../../utils/config';
import DialogBox from '../../components/KenDialogBox';
import CloseIcon from '../../assets/icons/Cross.png';
import { routes } from '../../utils/urls';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'relative',
  },
  hide: {
    display: 'none',
  },
  reSend: {
    cursor: 'pointer',
    float: 'right',
  },
  Heading: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: 24,
  },
  change: {
    cursor: 'pointer',
    color: theme.palette.KenColors.primary,
    fontSize: '15px',
  },
  registerLabel: {
    textAlign: 'start',
    marginBottom: '10px',
    color: theme.palette.KenColors.black,
    textTransform: 'capitalize',
    fontWeight: '600',
    fontSize: 16,
  },
  applyLabel: {
    fontSize: 14,
  },
  closeButtonContainer: {
    position: 'absolute',
    top: '-16px',
    right: '-16px',
  },
}));

export default withRouter(function ApplyForInfo(props) {
  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
});

const ApplyForForm = (props) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    setFieldTouched,
    currentRow,
    setFieldValue,
    handleClose,
    // applyingForMe,
    userData,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [myself] = React.useState(true);
  // const [applyingForSelf, setApplyingForSelf] = useState(applyingForMe);
  const history = useHistory();

  const [openDialog, setOpenDialog] = React.useState(false);

  const apply = () => {
    localStorage.setItem('applyingForSelf', values.applyingForSelf);
    history.push({
      pathname: `${routes.instructions}${currentRow.programId}`,
      search: `?name=${currentRow.programId}&instId=${currentRow.instituteId}&year=${currentRow.AcademicYear}`,
      state: {
        academicProgramDetails: currentRow,
        userDetails: {
          ...userData,
          applyingForSelf: values.applyingForSelf,
          relationWithApplicant: values.Relation,
        },
        applicantDetails: values.applyingForSelf ? userData.userDetails : {},
        applicationDetails: {
          draft: false,
        },
        ParentId: userData.ParentId,
        Email: userData.Email,
      },
    });
  };

  const handleApplyForSelf = (e) => {
    // setApplyingForSelf(e.target.checked);
    setFieldValue('applyingForSelf', e.target.checked);
    setFieldValue('Relation', '');
    touched.Relation = false;
  };

  const change = (name, e, index) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  return (
    <form>
      {currentRow && (
        <DialogBox
          title={`${t('labels:applyFor_dialogTitle')}`}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          message={`${t('labels:applyFor_dialogMessage')}`}
          okText={`${t('labels:applyFor_dialogOk')}`}
          notOkText={`${t('labels:applyFor_dialogNotOk')}`}
          width={'sm'}
          handleDialogSubmit={apply}
        >
          <Typography style={{ marginBottom: 8 }}>
            {t('labels:applyFor_dialogContent')}
            <span style={{ color: '#000000', fontWeight: 600 }}>
              {currentRow.academicProgram}
            </span>
          </Typography>
        </DialogBox>
      )}
      <Paper className={classes.paper} elevation={0}>
        <Box pt={1} className={classes.closeButtonContainer}>
          <IconButton aria-label='delete' color='primary' onClick={handleClose}>
            <img src={CloseIcon}></img>
          </IconButton>
        </Box>
        <Box textAlign='center'>
          <Box pt={1}>
            <Typography
              variant='body2'
              className={classes.registerLabel}
              style={{ fontSize: '14px' }}
            >
              <span className={classes.applyLabel}>
                {t('labels:applyFor_modalTitle')}
              </span>
            </Typography>
          </Box>
          <Box pt={1}>
            <div className={clsx({ [classes.hide]: !myself })}>
              <Grid container spacing={1}>
                {!values.applyingForSelf ? (
                  <Grid item xs={12} sm={12} md={12}>
                    <KenSelect
                      label='Relation'
                      name='Relation'
                      options={t('options:primaryRelations', {
                        returnObjects: true,
                      })}
                      onChange={change.bind(null, 'Relation')}
                      required={true}
                      value={values.Relation || ''}
                      errors={errors.Relation}
                      touched={touched.Relation}
                    />
                  </Grid>
                ) : null}

                <Grid>
                  <div className='applyselfLabel'>
                    <KenCheckbox
                      label={`${t('labels:applyFor_checkbox')}`}
                      name='applyingForSelf'
                      value={values.applyingForSelf}
                      onChange={(e) => {
                        handleApplyForSelf(e);
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Box>

          <Box
            display='flex'
            justifyContent='flex-end'
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            <KenButton variant='primary'>{t('buttons:go')}</KenButton>
          </Box>
        </Box>
      </Paper>
    </form>
  );
};

const FormikHoc = (props) => {
  const { t } = useTranslation();
  const { config } = React.useContext(configContext);
  const history = useHistory();
  const { currentRow } = props;
  const applyingForSelf =
    typeof config.isApplyingForSelf === Boolean
      ? config.isApplyingForSelf
      : true;
  const relation = '';
  const ApplyForFormik = withFormik({
    mapPropsToValues: () => ({
      applyingForSelf: applyingForSelf,
      Relation: relation,
    }),

    validationSchema: Yup.object({
      Relation: Yup.string().when('applyingForSelf', {
        is: false,
        then: Yup.string().required(t('validations:required')),
      }),
    }),

    handleSubmit: (values) => {
      history.push({
        pathname: `${routes.instructions}${currentRow.programId}`,
        search: `?name=${currentRow.academicProgram}&instId=${currentRow.instituteId}`,
        state: {
          academicProgramDetails: currentRow,
          userDetails: {},
          applicationDetails: {
            draft: false,
          },
          ParentId: '',
          Email: '',
        },
      });
    },

    displayName: 'ApplyForInformation',
  })(ApplyForForm);

  return <ApplyForFormik {...props} />;
};
